import { render, staticRenderFns } from "./db-backup.vue?vue&type=template&id=0b9b0c46&scoped=true&"
import script from "./db-backup.vue?vue&type=script&lang=js&"
export * from "./db-backup.vue?vue&type=script&lang=js&"
import style0 from "./db-backup.vue?vue&type=style&index=0&id=0b9b0c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b0c46",
  null
  
)

export default component.exports